export default [['1', '第三方组件']]
